import * as React from "react";
import { cn } from "@/utils/utils";
import IconContainer, { iconSize } from "@/components/ui/icon-container";
import { Button, ButtonProps } from "@/components/ui/button";

export type IconButtonSize = "xs" | "sm" | "md" | "lg" | "xl" | "2xl";

export type IconButtonVariant = "icon" | "iconWShadow" | "iconNoBg";

export interface IconButtonProps extends Omit<ButtonProps, "size"> {
  variant?: IconButtonVariant;
  size?: IconButtonSize;
}

const iconSizes: Record<IconButtonSize, iconSize> = {
  xs: "sm",
  sm: "5",
  md: "5",
  lg: "22",
  xl: "md",
  "2xl": "lg"
};

const buttonClassNames: Record<IconButtonSize, string> = {
  xs: "size-5 rounded-[6px]",
  sm: "size-6 rounded-[6px]",
  md: "size-7",
  lg: "size-8",
  xl: "size-9",
  "2xl": "size-12"
};

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      variant = "icon",
      className,
      size = "xl",
      destructive,
      iconColor = "primary",
      disabled,
      iconClassName,
      children,
      tooltipText,
      ...props
    },
    ref
  ) => {
    return (
      <Button
        variant={variant}
        size="icon"
        ref={ref}
        className={cn(buttonClassNames[size], className)}
        disabled={disabled}
        destructive={destructive}
        tooltipText={tooltipText}
        {...props}
      >
        <IconContainer
          size={iconSizes[size]}
          color={disabled ? "disabled" : destructive ? "negative" : iconColor}
          className={iconClassName}
        >
          {children}
        </IconContainer>
      </Button>
    );
  }
);
IconButton.displayName = "IconButton";

export { IconButton };
